import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import { makeStyles } from '@material-ui/core/styles';
import {Box, Paper} from '@material-ui/core';
import {useSelector} from "react-redux";
import {
    bbDoesCustomerHaveAccessToModule, isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import AlertDialog from "./PopupAlert";

const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',

    },
    blurred: {
        backgroundFilter: "blur(3px)",
    }
}));


// const BorderLinearProgressDeterminate = withStyles((theme) => ({
//     root: {
//         height: 10,
//         borderRadius: 5,
//         marginTop: -10,
//     },
//     colorPrimary: {
//         backgroundColor: "rgba(0, 0, 0, 0.0)",
//     },
//     bar: {
//         // borderRadius: 5,
//         // backgroundColor: '#1a90ff',
//     },
// }))(LinearProgress);
// const BorderLinearProgressIndeterminate = withStyles((theme) => ({
//     root: {
//         height: 10,
//         borderRadius: 5,
//         // marginTop: -10,
//     },
//     colorPrimary: {
//         backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
//     },
//     bar: {
//         borderRadius: 5,
//         backgroundColor: '#9096FD',
//     },
// }))(LinearProgress);

const SimpleBackdrop = (props) => {
    const {moduleId} = props;

    const classes = useStyles();
    const {customerInView, customers} = useSelector(({customer}) => customer);
    const authUser = useSelector(({auth}) => auth.authUser);
    const customer = customers ? customers[customerInView] : null;
    // const customerStatus = customer ? customer.StatusId : null;

    const hasModuleAccess = bbDoesCustomerHaveAccessToModule(customer, moduleId)
    const isAdmin = isCurrentUserMemberOf(authUser,"admin");

    const open = !hasModuleAccess && !isAdmin;

    // useEffect( () => {
    //     setCustomerStatus(customer ? customer.StatusId : null);
    //     setOpen(customerStatus !== 4);
    // }, [customerInView])

    // const handleClose = () => {
    //     setOpen(false);
    // };
    // const handleToggle = () => {
    //     setOpen(!open);
    // };

    if(!hasModuleAccess && isAdmin) {
        return <AlertDialog
            title={"Heads up"}
            description={`You have access to this because you are an admin, but ${customer.CustomerName} does not have access to this module.`}
            customerId={customerInView}
            />
    } else {
        return (
            <Box>
                {/*<Button variant="outlined" color="primary" onClick={handleToggle}>*/}
                {/*    Show backdrop*/}
                {/*</Button>*/}
                <Backdrop className={classes.backdrop} open={open}>
                    <Paper className={"p-3"} style={{ textAlign: "center" }}>

                        <div className={classes.paper}>
                            <h2>Module Not Accessible</h2>
                            <h3 id="transition-modal-title">{customer.CustomerName}</h3>
                            {/*<p>Added: {bbFormattedDateString(customer.CreatedDate)}</p>*/}
                            <p id="transition-modal-description">Your company doesn't have access to this module.</p>
                            <p id="transition-modal-description">This could occur if you have stumbled upon a feature under construction or if there is a misconfiguration.</p>
                            <p id="transition-modal-description">Please contact support@breachbits.com for access.</p>
                            {/*<p>Progress: </p>*/}

                            {/*<BorderLinearProgressIndeterminate/>*/}
                            {/*<BorderLinearProgressDeterminate variant="determinate" value={(customer.StatusId + 1) * 20}/>*/}


                            <br/>
                            <small>Status ID: {customer.StatusId}</small>
                            <br/>
                            <small>Module Status: {customer.hasOwnProperty("Modules") ? Object.keys(customer.Modules) : "No Modules"} {hasModuleAccess ? "Yes" : hasModuleAccess === false ? "No" : "Null"}</small>
                        </div>
                    </Paper>
                </Backdrop>
            </Box>
        );
    }

}

// Jan 2021 status codes
// Id	Name	Description
// 0	New submission via website	Customer information has been received via the BreachBits website, but no processing or onboarding has yet taken place.
// 1	New submission via BreachBoard	Customer information has been received through the BreachBoard, but no verification or onboarding has been conducted yet.
// 2	New submission data being parsed and verified	Customer information is being processed, verified and handled in preparation of onboarding.
// 3	Onboarding in progress	Customer is currently being onboarded.
// 4	Service active	Customer has successfully been onboarded on to CIRT, and their service is active.
// 5	Onboarding error	There was an issue onboarding this customer.  Manual intervention is needed.
// 6	Service on hold	The service for this customer has been placed on hold by BreachBits Staff.

// const TransitionsModal = (props) => {
//     const classes = useStyles();
//     const {customer} = props
//     console.log("loading the customer status modal with customer", customer);
//     const [customerStatus, setCustomerStatus] = React.useState(customer ? customer.StatusId : null);
//     const [open, setOpen] = React.useState(customerStatus !== 4);
//
//     const handleOpen = () => {
//         setOpen(true);
//     };
//
//     const handleClose = () => {
//         setOpen(false);
//     };
//
//     return (
//         <div>
//             {/*<button type="button" onClick={handleOpen}>*/}
//             {/*    react-transition-group*/}
//             {/*</button>*/}
//             <Modal
//                 aria-labelledby="transition-modal-title"
//                 aria-describedby="transition-modal-description"
//                 className={classes.modal}
//                 open={open}
//                 onClose={handleClose}
//                 closeAfterTransition
//                 // disablePortal
//                 disableBackdropClick
//                 BackdropComponent={Backdrop}
//                 BackdropProps={{
//                     timeout: 500,
//                 }}
//             >
//                 <Fade in={open}>
//                     <div className={classes.paper}>
//                         <h2>Hang Tight!</h2>
//                         <h3 id="transition-modal-title">{customer.CustomerName}</h3>
//                         <p id="transition-modal-description">This client's data is being built on the backend.  Check back soon.</p>
//                     </div>
//                 </Fade>
//             </Modal>
//         </div>
//     );
// }
export default SimpleBackdrop;
